import { _ as r } from "./_createCaseFirst.js";
var e = r, a = e("toUpperCase"), t = a;
export {
  t as u
};
//# sourceMappingURL=upperFirst.js.map
